const SEARCH_PROP_NAME = 'search'

module.exports = SEARCH_PROP_NAME
